import { Suspense, useState } from 'react';
import { MarketHeader } from '@market/react';
import { useTranslation, Trans } from 'react-i18next';
import TranslationsLoader from 'typescript/components/translations_loader';
import PageLoader from 'typescript/components/page_loader';
import ShopErrorBoundary from 'typescript/components/shop_error_boundary';

import RedeemForm from './components/redeem_form';
import RedeemSuccess from './components/redeem_success';
import styles from './redeem.module.scss';
import { REDEEM_TERMS_URL } from './utils';
import CustomQueryClientProvider from 'typescript/providers/custom_query_client_provider';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export { REDEEM_INPUT_TEST_ID } from './components/redeem_form';
export { REDEEM_SUCCESS_TEST_ID } from './components/redeem_success';

interface RedeemContentProps {
  storeCode: string;
  languageCode: string;
}

export const RedeemContent = ({
  storeCode,
  languageCode,
}: RedeemContentProps) => {
  const { t } = useTranslation();
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <div className={styles.redeemContainer}>
      <MarketHeader>
        <h1>{t('redeem.title')}</h1>
      </MarketHeader>
      <p>{t('redeem.subtext')}</p>
      {isSuccess ? (
        <RedeemSuccess />
      ) : (
        <RedeemForm onSuccess={() => setIsSuccess(true)} />
      )}
      <p>
        <Trans
          i18nKey="redeem.terms"
          components={{
            a: (
              <a
                href={`/${storeCode}/${languageCode}${REDEEM_TERMS_URL}`}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      </p>
    </div>
  );
};

const RedeemApp = ({ storeCode, languageCode }: RedeemContentProps) => {
  return (
    <ShopErrorBoundary appName="redeem">
      <Suspense fallback={<PageLoader delayMs={500} />}>
        <TranslationsLoader>
          <CustomQueryClientProvider>
            <RedeemContent storeCode={storeCode} languageCode={languageCode} />
            <ReactQueryDevtools initialIsOpen={false} />
          </CustomQueryClientProvider>
        </TranslationsLoader>
      </Suspense>
    </ShopErrorBoundary>
  );
};

export default RedeemApp;
